document.querySelectorAll('[data-toggle]').forEach(toggleParent => {

  const suffix = toggleParent.hasAttribute('data-toggle-suffix') ? '-' + toggleParent.getAttribute('data-toggle-suffix') : ''


  const anchor = toggleParent.querySelector('[data-toggle-anchor]')
  const id = anchor ? anchor.getAttribute('id') : toggleParent.getAttribute('id')

  console.log('Initializing toggle for:', id)

  const triggers = toggleParent.querySelectorAll(`[data-toggle-trigger${suffix}]`)
  const className = toggleParent.hasAttribute(`data-toggle-class${suffix}`) ? toggleParent.getAttribute(`data-toggle-class${suffix}`) : 'is-active'

  const autoHeightElement = toggleParent.querySelector('[data-toggle-auto-height]')
  const eventName = toggleParent.hasAttribute(`data-toggle-event${suffix}`) ? toggleParent.getAttribute(`data-toggle-event${suffix}`) : 'toggle:global'

  const addClassToElementSelector = toggleParent.hasAttribute(`data-toggle-add-to-id${suffix}`) ? toggleParent.getAttribute(`data-toggle-add-to-id${suffix}`) : false
  const addClassToElement = document.getElementById(addClassToElementSelector)

  const targetElement = addClassToElementSelector ? addClassToElement : toggleParent

  const toggleHeight = () => {
    let isToggled = targetElement.classList.contains(className)
    let event = new CustomEvent(eventName, {
      detail: { isToggled, toggleParent, triggers, className, autoHeightElement }
    })

    if (autoHeightElement) autoHeightElement.style.maxHeight = isToggled ? autoHeightElement.scrollHeight + 'px' : 0

    window.dispatchEvent(event)
  }

  const toggle = (e, updateHash = true) => {
    targetElement.classList.toggle(className)
    if (id && updateHash) history.replaceState(null, '', targetElement.classList.contains(className) ? '#' + id : location.pathname + location.search)
    toggleHeight()
  }

  const checkHash = () => {
    if (id && location.hash === '#' + id && !targetElement.classList.contains(className)) toggle(null, false)
  }

  triggers.forEach(trigger => trigger.addEventListener('click', toggle))
  window.addEventListener('resize', toggleHeight)
  window.addEventListener('load', () => { toggleHeight(); checkHash() })
  window.addEventListener('hashchange', checkHash)
})
